/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calm_Strong_Hound_BelongInputs */

const fr_calm_strong_hound_belong = /** @type {(inputs: Calm_Strong_Hound_BelongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thème`)
};

/**

* @param {Calm_Strong_Hound_BelongInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const calm_strong_hound_belong = /** @type {((inputs?: Calm_Strong_Hound_BelongInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calm_Strong_Hound_BelongInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_calm_strong_hound_belong(inputs)
});